import * as React from "react";
import PropTypes from "prop-types";
import { IMaskInput } from "react-imask";
import FormControl from "@mui/material/FormControl";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";

// Custom mask component for Tamil Nadu landline format (e.g. +91 44 2257 1234)
const LandlineMaskCustom = React.forwardRef(function LandlineMaskCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="+91 00 0000 0000" // Example: +91 44 2257 1234
      definitions={{
        "#": /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

LandlineMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function LandlineNumberField({ control, name, label, error, size = "small" }) {
  return (
    <FormControl fullWidth className={error ? "Text-error-field" : ""}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label={label || "Landline Number"}
            size={size}
            fullWidth
            placeholder="+91 44 2257 1234"
            InputProps={{
              inputComponent: LandlineMaskCustom,
            }}
            error={!!error}
            helperText={error ? error.message : ""}
          />
        )}
      />
    </FormControl>
  );
}
